export const TUBI_CHANNELS = [
  {
    number: "1000",
    name: "NFL Channel",
    category: "Sports",
    type: "TUBI",
    tubiContentId: "613761",
    tubiSlug: "nfl-EcjfnZ",
    preview: "https://images.unsplash.com/photo-1508098682722-e99c43a406b2?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "NFL Channel",
        start: "8:00 PM",
        end: "10:00 PM",
        width: 4,
        rating: "TV-PG",
        genres: ["Sports", "Football"],
        summary: "Live NFL programming from Tubi.",
      },
    ],
  },
  {
    number: "1001",
    name: "MLB Channel",
    category: "Sports",
    type: "TUBI",
    tubiContentId: "613765",
    tubiSlug: "mlb2-RR0NCJ",
    preview: "https://images.unsplash.com/photo-1508344928928-7165b67de128?auto=format&fit=crop&w=1400&q=80",
    programs: [
      {
        title: "MLB Channel",
        start: "8:00 PM",
        end: "10:00 PM",
        width: 4,
        rating: "TV-PG",
        genres: ["Sports", "Baseball"],
        summary: "Live MLB programming from Tubi.",
      },
    ],
  },
];